/**
 * True while a query has never produced data and is either fetching or paused.
 *
 * #1569/#1570: TanStack's `isLoading` is `isPending && isFetching`. A list
 * request that fails without a response is retried once
 * (`retryTransportFailureOnce`), and the connectivity controller has already set
 * `onlineManager` offline, so that retry PAUSES: `status:'pending'`,
 * `fetchStatus:'paused'`. `isLoading` is false there and `isError` is false, so a
 * list that reads `isLoading` fell through to its empty state ("No packets match
 * the current filters", "0 packets", "No labels yet") on a page that had never
 * loaded. This answers the question those screens actually ask: "is there still
 * no answer coming?". A disabled query (pending + idle) has nothing coming, so it
 * is false.
 */
export function firstLoadPending(query: {
  isPending: boolean;
  fetchStatus: 'fetching' | 'paused' | 'idle';
}): boolean {
  return query.isPending && query.fetchStatus !== 'idle';
}
